import { createFileRoute } from '@tanstack/react-router'
import { OrderDetailPanel } from '@/components/me/order-detail-panel'

export const Route = createFileRoute('/orders/$orderNo')({
  component: OrderDetailPanel,
})
